// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3ZmN3","validationTips":"StatementDescriptor_validationTips__2s6SL"};